import React from 'react';

import OrdersPage from '@/features/orders/pages/orders.page';

const OrdersRoute = () => {
  return <OrdersPage />;
};

export default OrdersRoute;
